<template>
  <div class="column-acoes">
    <el-dropdown trigger="click">
      <span :style="`color: ${estilo.aplicacao.corPrimariaAplicacao}`" class="el-dropdown-link">Ações <i class="el-icon-more"></i></span>
      <el-dropdown-menu slot="dropdown" class="acoes-dropdown">
        <el-dropdown-item v-for="(acao, index) in column.acoes" :key="index">
          <el-button type="text" @click="acao.func(row)">{{acao.label}}</el-button>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-button type="text"></el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AcoesItem',
  props: ['column', 'row'],
  computed: {
    ...mapGetters('SetupApp', ['estilo'])
  }
}
</script>
